import { useQuery } from '@tanstack/react-query';
import { graphql } from '../gql/gql';
import { graphqlRequest, shouldRetryQuery } from '../utils/graphqlClient';
import { BoatQuery } from '../gql/graphql';

const boat = graphql(/* GraphQL */ `
  query boat($boatId: Int, $slug: String) {
    boat(boatId: $boatId, slug: $slug) {
      boatId
      name
      currency
    }
  }
`);

const useGetBoat = (boatId?: number, slug?: string) => {
  const { data, isLoading } = useQuery<BoatQuery>({
    queryKey: ['boat', boatId],
    queryFn: async () =>
      graphqlRequest<BoatQuery>(boat, {
        boatId,
        slug,
      }), // Public endpoint, no auth needed
    staleTime: 3600000,
    enabled: !!boatId || !!slug,
    retry: shouldRetryQuery,
  });

  return {
    boat: data,
    boatLoading: isLoading,
  };
};

export default useGetBoat;
